import OkTableConfigType from '@/@bya3/components/tables/ok-table/OkTableConfigType'
import { API_URL } from '@/constants/config'

const PlansTableConfig: OkTableConfigType = {
  mode: 'remote',
  url: `${API_URL}/admin/packages`,
  rowsPath: 'plans',
  rowClickable: true,
  attachPageId: false,
  actionFirst: true,
  actions: [
    {
      label: 'forms.edit',
      eventName: 'edit',
      icon: 'EditIcon',
    },
    {
      label: 'forms.delete',
      eventName: 'delete',
      icon: 'Trash2Icon',
    },
  ],
  columns: [
    {
      label: 'fields.name',
      field: 'name',
    },
    {
      label: 'general.price',
      field: 'price',
    },
    {
      label: 'general.media-type',
      field: 'media_type',
    },
    {
      label: 'reply.replies_count',
      field: 'count',
    },
  ],
  paginationOptions: {
    enabled: true,
  },
  sortOptions: {
    enabled: false,
  },

  filters: [
    {
      label: 'general.media-type',
      query: 'media_type',
      colLength: 3,
      type: 'select',
      multiple: false,
      options: [{ text: 'general.fb', value: 'fb' }, { text: 'general.ig', value: 'ig' }],
      optionsLabel: { keyLabel: 'text', valueLabel: 'value', translate: true },
    },
  ],
}

export default PlansTableConfig
